import React from "react";
import { Button, DialogNew, Disclose, Typography } from "@optimizely/axiom";
import styles from "./GenAICleanupRequiredDialog.module.scss";
import { useOpalBranding } from "../../../hooks/useOpalBranding/useOpalBranding";

type GenAICleanupRequiredDialogProps = {
    onClose: () => void;
    productGroupNames: string[];
    otherGroupNames: string[];
};

export const GenAICleanupRequiredDialog = ({
    onClose,
    productGroupNames,
    otherGroupNames
}: GenAICleanupRequiredDialogProps) => {
    const { opalName } = useOpalBranding();

    return (
        <DialogNew
            data-cy="genai-cleanup-required-modal"
            footerButtonList={[
                <Button key={0} data-cy="genai-cleanup-close-button" style="highlight" onClick={onClose}>
                    Close
                </Button>
            ]}
            title={`Complete Steps To Disable ${opalName}`}
            hasCloseButton
            hasOverlay
            onClose={onClose}
        >
            <div className="push--bottom">
                <Typography type="body" tag="div">
                    We found {opalName} access that must be removed before {opalName} can be disabled.
                </Typography>
                {productGroupNames.length > 0 && (
                    <div className="push-triple--top">
                        <Disclose title={`Remove users from all ${opalName} product groups`}>
                            <ul
                                data-cy="genai-product-group-list"
                                className={`oui-list oui-list--bullet push-double--bottom push-double--left ${styles["group-list"]}`}
                            >
                                {productGroupNames.map((name, index) => (
                                    <li key={index}>
                                        <Typography type="body">{name}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Disclose>
                    </div>
                )}
                {otherGroupNames.length > 0 && (
                    <div className="push-triple--top">
                        <Disclose title={`Remove ${opalName} permissions from the following custom groups`}>
                            <ul
                                data-cy="genai-custom-group-list"
                                className={`oui-list oui-list--bullet push-double--bottom push-double--left ${styles["group-list"]}`}
                            >
                                {otherGroupNames.map((name, index) => (
                                    <li key={index}>
                                        <Typography type="body">{name}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Disclose>
                    </div>
                )}
                <Typography type="body" className="push-triple--top" tag="div">
                    You can re-enable {opalName} later, but your current {opalName} permission settings will not be
                    restored automatically.
                </Typography>
                <Typography type="body" className="push--top" tag="div">
                    Only proceed if you no longer need these permission settings.
                </Typography>
            </div>
        </DialogNew>
    );
};

GenAICleanupRequiredDialog.displayName = "GenAICleanupRequiredDialog";
